module.exports = __webpack_public_path__ + "img/store_TikTok_brown.4ed4205d.svg";